var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"app-main"},[_c('ct-head'),_c('div',{staticClass:"content-box"},[_c('router-view')],1),_c('back-top'),_c('ct-foot')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }